module.exports = __webpack_public_path__ + "img/bg-init-left.cf6078ef.png";